// Libraries
import { Button, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, useDisclosure } from '@chakra-ui/react';
import { Fragment, ReactElement } from 'react';
// Types
import { AdaptableDialogProps } from '../../AdaptableDialog.types';

/**
 * A custom drawer component that can be used to display content in a drawer format.
 * This component is adaptable to different screen sizes.
 *
 * @component
 * @param {AdaptableDialogProps} props - The props for the CustomDrawer component.
 * @returns {ReactElement} The CustomDrawer component.
 */
export const CustomDrawer = ({ children, buttonContent }: AdaptableDialogProps): ReactElement => {
  const disclosure = useDisclosure();

  return (
    <Fragment>
      <Button onClick={disclosure.onOpen} variant='wrapper' p={2}>
        {buttonContent}
      </Button>
      <Drawer isOpen={disclosure.isOpen} onClose={disclosure.onClose} placement='bottom'>
        <DrawerOverlay />
        <DrawerContent bg='transparent' mb={-3}>
          {children}
          <DrawerCloseButton />
        </DrawerContent>
      </Drawer>
    </Fragment>
  );
};
